import { useQuery } from '@tanstack/react-query';
import { useAlgo } from './useAlgo';

export default function useJobGenerationCooldown() {
  const { address } = useAlgo();

  const cooldownQuery = useQuery({
    queryKey: ['job-generation-cooldown', address],
    queryFn: async () => {
      if (!address) return null;

      try {
        const response = await fetch('/api/jobs/generate-cooldown-check', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ address }),
        });

        const data = await response.json();

        if (response.status === 429) {
          return {
            isOnCooldown: true,
            cooldownEndsAt: data.cooldownEndsAt,
            message: data.error,
          };
        }

        if (response.ok) {
          return {
            isOnCooldown: false,
            cooldownEndsAt: null,
            message: null,
          };
        }

        throw new Error(data.error || 'Failed to check cooldown');
      } catch (error) {
        console.error('Error checking job generation cooldown:', error);
        return {
          isOnCooldown: false,
          cooldownEndsAt: null,
          message: null,
        };
      }
    },
    enabled: !!address,
    refetchInterval: (data) => {
      if (data?.isOnCooldown) {
        return 60000;
      }
      return false;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retry: false,
  });

  const { data: cooldownData, isLoading: loading, refetch } = cooldownQuery;

  return {
    isOnCooldown: cooldownData?.isOnCooldown || false,
    cooldownEndsAt: cooldownData?.cooldownEndsAt,
    message: cooldownData?.message,
    loading,
    refetch,
  };
}
